<template>
    <!-- 工作人员监考详情 -->
    <el-dialog :title="detailTextConfig.reviewerTitle" v-if="dialogVisible" :visible.sync="dialogVisible" width="960px" @close="close"
               :close-on-click-modal="false" :close-on-press-escape="false">

        <!-- 基本信息部分 -->
        <div class="section">
            <div class="section-header">
                <div class="blue-block"></div>
                <h3 class="section-title">{{ basicTextConfig.title }}</h3>
            </div>
            <div class="basic-info-table">

                <div class="info-row">
                    <div class="info-label">{{ basicTextConfig.reviewerName }}</div>
                    <div class="info-value">
                        <span>{{ form.reviewerName }}</span>
                        <span v-if="form.ifRemark" class="lockedClass">记录</span>
                    </div>
                    <div class="info-label">{{ basicTextConfig.idCardNo }}</div>
                    <div class="info-value">{{ maskIdCard(form.idCardNo) }}</div>
                </div>

                <div class="info-row">
                    <div class="info-label">{{ basicTextConfig.deviceEnv }}</div>
                    <div class="info-value">{{ form.deviceEnv }}</div>
                    <div class="info-label">{{ basicTextConfig.loginIp }}</div>
                    <div class="info-value">{{ form.loginIp }}</div>
                </div>

            </div>
        </div>

        <!-- 身份验证信息 -->
        <div class="section">
            <div class="section-header">
                <div class="blue-block"></div>
                <h3 class="section-title">{{ faceCheckTextConfig.title }}</h3>
            </div>
            <div class="basic-info-table">

                <div class="info-row">
                    <div class="info-label">{{ faceCheckTextConfig.checkTime }}</div>
                    <div class="info-value">{{ form.validateDatetime }}</div>
                    <div class="info-label">{{ faceCheckTextConfig.checkStatus }}</div>
                    <div class="info-value">
                        <span :class="{'not-pass-text': form.faceCheckStatus === '未通过'}">{{ form.faceCheckStatus }}</span>
                        <el-button
                                v-if="!form.manualCheck && form.faceCheckStatus === '未通过'"
                                type="success"
                                size="mini"
                                style="margin-left: 12px;"
                                @click="handleManualCheck"
                        >人工审核通过
                        </el-button>
                    </div>
                </div>
                <div class="info-row">
                    <div class="info-label">{{ faceCheckTextConfig.sceneImg }}</div>
                    <div class="info-value">
                        <img :src="form.snapshotFaceImg" v-if="form.snapshotFaceImg" style="height: 200px;">
                    </div>
                    <div class="info-label"></div>
                    <div class="info-value"></div>
                </div>

            </div>
        </div>

    </el-dialog>
</template>

<script>
import {postInvigilate} from "@/api/invigilate";

export default {
    props: ['row', 'show'],
    data() {
        return {
            dialogVisible: false,
            form: {
                id: null,
                reviewerName: '',
                idCardNo: '',//身份证
                loginIp: '',
                deviceEnv: '',
                ifRemark: null,
                validateDatetime: '',//最新验证时间
                faceCheckStatus: '',//最新验证结果
                snapshotFaceImg: '',//最新验证图片地址
                manualCheck: '',//是否为人工校验
            },
        };
    },
    computed: {
        detailTextConfig() {
            return this.$store.state.global.textConfig.backend.invigilateDetail.detail
        },
        basicTextConfig() {
            return this.detailTextConfig.basic
        },
        faceCheckTextConfig() {
            return this.detailTextConfig.faceCheck
        },
    },
    watch: {
        show() {
            this.dialogVisible = this.show;
        },
        row() {
            if (this.row) {
                this.form = {
                    ...this.form,
                    ...this.row
                }

            }
        }
    },
    methods: {
        close() {
            this.dialogVisible = false
            this.$emit('close', false)
        },
        maskIdCard(idCard) {
            if (!idCard || idCard.length < 9) {
                return idCard
            }
            return idCard.substring(0, 6) + '********' + idCard.substring(idCard.length - 3)
        },
        handleManualCheck() {
            this.$confirm('通过后验证结果不可修改，请谨慎操作！确认审核通过？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                const data = {
                    id: this.form.id,
                    examId: this.form.examId,
                    reviewerId: this.form.reviewerId,
                    manualCheck: true,
                    faceCheckStatus: 'PASS'
                }
                postInvigilate(data).then(res => {
                    if (res.status === 200) {
                        this.$message({
                            type: 'success',
                            message: '人工审核通过，操作成功！'
                        })
                        this.form.manualCheck = true
                        this.form.faceCheckStatus = 'PASS'
                        this.$emit('close', false, true)
                    }
                })
            }).catch(() => {
            })
        }


    }
}
</script>

<style scoped>
.section {
    margin-bottom: 24px;
}

.section-header {
    display: flex;
    align-items: center;
    margin-bottom: 12px;
}

.blue-block {
    width: 4px;
    height: 16px;
    background-color: #1890ff;
    margin-right: 8px;
    border-radius: 2px;
}

.section-title {
    color: #303133;
    font-size: 16px;
    font-weight: bold;
    margin: 0;
}

/* 基本信息表格样式 */
.basic-info-table {
    border: 1px solid #ebeef5;
    border-radius: 4px;
    overflow: hidden;
}

.info-row {
    display: flex;
    border-bottom: 1px solid #ebeef5;
}

.info-row:last-child {
    border-bottom: none;
}

.info-label {
    width: 100px;
    padding: 12px 8px;
    background-color: #fafafa;
    border-right: 1px solid #ebeef5;
    font-weight: bold;
    color: #606266;
    display: flex;
    align-items: center;
}

.info-value {
    flex: 1;
    padding: 12px 15px;
    color: #303133;
    display: flex;
    align-items: center;
    border-right: 1px solid #ebeef5;
}

.info-value:last-child {
    border-right: none;
}

.monitoring-info {
    padding: 12px;
    border-radius: 4px;
}

.monitoring-info p {
    /*margin: 8px 0;*/
}

.admin-info {
    margin-top: 16px;
    /*background-color: #f5f7fa;*/
    color: #606266;
    font-color: #f5f7fa;
    padding-top: 12px;
    /*border-top: 1px dashed #dcdfe6;*/
}

.not-pass-text {
    color: #f56c6c;
    font-weight: bold;
}

.lockedClass {
    background-color: #FF9502;
    /*background-color: #FF455B;*/
    display: inline-block;
    padding: 0 2px;
    text-align: center;
    vertical-align: middle;
    font-style: normal;
    color: #fff;
    overflow: hidden;
    line-height: 16px;
    height: 16px;
    font-size: 10px;
    border-radius: 4px;
    font-weight: 200;
}
</style>
